export default __webpack_public_path__ + "static/media/dobbies.abb45280.png";